import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=64ecd640&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=64ecd640&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=64ecd640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ecd640",
  null
  
)

export default component.exports